// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2L703","choiceBoxes":"toolbarselects_choiceBoxes__l7iza","simpleField":"toolbarselects_simpleField__1bX8r"};